import { Path } from 'react-native-svg';
export const AnimatedSvgPath = Path;
